<template>
  <div
    class="room-list"
    :style="{
      'min-height': app.isRecorder ? '625px' : currentHeight + 'px',
      'max-height': app.dockRight ? undefined : currentHeight + 'px',
    }"
  >
    <RoomListHeader />
    <div class="room-list-body">
      <Room v-for="room in rooms" :key="room.name" :name="room.name" />
    </div>
    <div v-show="!app.dockRight" class="wall" @pointerdown="moveWall" />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { DEFAULT_ROOMS_HEIGHT } from '../config';
import { getApp } from '../models/App';
import { Room as RoomModel } from '../models/Room';
import Room from './Room.vue';
import RoomListHeader from './RoomListHeader.vue';

const app = getApp();
const rooms = computed(() => RoomModel.all());

const currentHeight = ref(Number(localStorage.getItem('roomsHeight')) || DEFAULT_ROOMS_HEIGHT);

const moveWall = (ev: PointerEvent) => {
  (ev.target as HTMLDivElement).setPointerCapture(ev.pointerId);

  const onUp = () => {
    (ev.target as HTMLDivElement).releasePointerCapture(ev.pointerId);
    document.removeEventListener('pointermove', onMove);
    document.removeEventListener('pointerup', onUp);
  };

  const onMove = (ev: PointerEvent) => {
    currentHeight.value += ev.movementY;
    localStorage.setItem('roomsHeight', currentHeight.value.toString());
  };

  document.addEventListener('pointermove', onMove);
  document.addEventListener('pointerup', onUp);
};
</script>

<style scoped>
div.room-list {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  position: relative;
}

div.room-list > div.room-list-body {
  display: flex;
  flex-direction: column;
  user-select: none;
  overflow: auto;
}

div.room-list > div.wall {
  position: absolute;
  bottom: -3px;
  width: 100%;
  height: 6px;
  cursor: n-resize;
}

div.room-list > div.wall:hover {
  background: rgba(0, 0, 0, 0.5);
}
</style>
